import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const ReferenceBookTicketTypes = lazy(() => import("@/pages/ReferenceBooks/Lists/Appeals/ReferenceBookTicketTypes"));
const ReferenceBookTicketUrgency = lazy(() => import("@/pages/ReferenceBooks/Lists/Appeals/ReferenceBookTicketUrgency"));
const ReferenceBookTicketStatuses = lazy(() => import("@/pages/ReferenceBooks/Lists/Appeals/ReferenceBookTicketStatuses"));
const ReferenceBookTicketResponsesStandards = lazy(() => import("@/pages/ReferenceBooks/Lists/Appeals/ReferenceBookTicketResponsesStandards"));
const ReferenceBookTicketTemplates = lazy(() => import("@/pages/ReferenceBooks/Lists/Appeals/ReferenceBookTicketTemplates"));

const urlsConfig = new UrlsConfig();

export function referenceBookAppealsRoutes() {
    return (
      <>
          <Route
            path={urlsConfig.referenceBookTicketTypes.to}
            element={<ReferenceBookTicketTypes/>}
          />
          <Route
            path={urlsConfig.referenceBookTicketUrgency.to}
            element={<ReferenceBookTicketUrgency/>}
          />
          <Route
            path={urlsConfig.referenceBookTicketStatuses.to}
            element={<ReferenceBookTicketStatuses/>}
          />
          <Route
            path={urlsConfig.referenceBookTicketResponsesStandards.to}
            element={<ReferenceBookTicketResponsesStandards/>}
          />
          <Route path={urlsConfig.referenceBookTicketTemplates.to} element={<ReferenceBookTicketTemplates/>}/>
      </>
    );
}
